import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    constructor(private http: HttpClient) {
    }

    // public icGet method.  This performs the GET operation for any inContact GET API
    public icGet(url: string): Observable<any> {
        return this.http.get(url);
    }

    public textGet(url: string): Observable<any> {
        return this.http.get(url, { responseType: 'text' });
    }

    // public icPut method.  This performas the PUT operation for any inContact PUT API
    public icPut(url: string, data: string): Observable<any> {
        return this.http.put(url, data);
    }

    // public icPost method.  This performs the PUT operation for any inContact POST API
    public icPost(url: string, data?: string): Observable<any> {
        return this.http.post(url, data);
    }

    // public icDelete method.  This performs the PUT operation for any inContact DELETE API
    public icDelete(url: string, data?: any): Observable<any> {
        if (data) {
            const httpOptions = {
                body: data
            };
            return this.http.delete(url, httpOptions);
        } else {
            return this.http.delete(url);
        }
    }

    // private handleError(error: HttpErrorResponse): Observable<any> {
    //     console.log(error);
    //     let errorMessage = '';
    //     if (error.error instanceof ErrorEvent) {
    //         // A client-side or network error occurred. Handle it accordingly.
    //         // console.error('An error occurred:', error.error.message);
    //         errorMessage = 'An error occurred: ' + error.error.message;
    //     } else {
    //         //console.log(error);
    //         // backend returned an unsuccessful response code.
    //         // response body may contain clues as to what went wrong.
    //         // console.error('Backend return code ' + error.status,
    //         // 'body was: ' + JSON.stringify(error.error));
    //         if (error.error && error.error.error_description) {
    //             errorMessage = 'An error occurred: ' + error.error.error_description;
    //         }
    //         if (error.error && error.error.error) {
    //             errorMessage = 'An error occurred: ' + error.error.error;
    //         }
    //         else if (error.error) {
    //             errorMessage = 'An error occurred: ' + error.error;
    //         } else if (error.status) {
    //             errorMessage = 'An error occurred: Error Code: ' + error.status + ' Message: ' + error.message;
    //         } else if (error.statusText) {
    //             errorMessage = 'An error occurred: ' + error.statusText;
    //         } else {
    //             errorMessage = error.toString();
    //         }
    //
    //     }
    //     error.error.aac_error = errorMessage;
    //     // return an observable with a user-facing error message
    //     console.log(error);
    //     return throwError(() => error);
    // }

}
